import { createContext, useContext, RefObject } from 'react';

type LayoutRefContextType = RefObject<HTMLDivElement> | null;

export const LayoutRefContext = createContext<LayoutRefContextType>(null);

export const useLayoutRef = () => useContext(LayoutRefContext);
